import React from "react";
import { AuthContext } from "../../../lib/AuthContext";
import ParentComponent from "../../../lib/ParentComponent";
import firebase, { auth } from "../../../lib/firebase";
import Utils from "../../../Utils";
import { NavLink } from "react-router-dom";
import ar from "../../../locale";
import { deleteUrl } from "../../../constants";

export default class EgyptianCoachExpectations extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
      polls: [],
      token: null,
      deleting: {},
    };
    this.path = "polls/expectations/";
    this.pollsRef = firebase.database().ref(this.path);
  }

  componentDidMount() {
    super.componentDidMount();
    auth.currentUser.getIdToken().then((token) => {
      this.state.token = token;
      this.updateState();
    });
    this.pollsRef.on("value", (response) => {
      this.state.polls = Utils.convertToArrayWithInsertionOrder(response.val());
      this.updateState();
    });
    window.Tablesaw.init(this.$("#sawtable"));
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.pollsRef.off("value");
  }

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  renderPolls = (poll) => {
    return (
      <tr key={poll.key}>
        <td className="title">
          <NavLink to={"/coach/expectations/" + poll.key}>{poll.title}</NavLink>
        </td>
        <td>{poll.votes}</td>
        <td>
          {!this.state.deleting[poll.key] && (
            <i
              className="fa fa-trash text-danger cursor-pointer"
              title={ar.delete}
              onClick={this.deleteConfirmation.bind(this, poll)}
            ></i>
          )}
          {this.state.deleting[poll.key] && (
            <div
              className="d-inline-block spinner-border spinner-border-sm text-danger"
              role="status"
            ></div>
          )}
        </td>
      </tr>
    );
  };

  deleteConfirmation = (poll) => {
    this.confirm(null, this.deletePoll.bind(this, poll));
  };

  deletePoll = (poll) => {
    this.state.deleting[poll.key] = true;
    this.updateState();
    fetch(deleteUrl, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.token,
      },
      body: JSON.stringify({
        path: this.path + poll.key,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        this.updateState();
      })
      .catch((error) => {
        this.state.deleting[poll.key] = false;
        this.showError(error.message);
      });
  };

  render() {
    return (
      <div className="page-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-8 mt-2">
              <h2 className="card-title">{ar.expectations}</h2>
              <h5 className="card-subtitle">
                {ar.total} {this.state.polls.length}
              </h5>
            </div>
            <div className="col-sm-4 mt-2 text-md-left">
              <NavLink
                to="/coach/expectations/add"
                className="btn btn-info btn-rounded"
              >
                {ar.add_new}
              </NavLink>
            </div>
          </div>
          <table
            id="sawtable"
            className="mt-3 tablesaw table-bordered table-striped table-hover table no-wrap"
            data-tablesaw-mode="swipe"
          >
            <thead>
              <tr>
                <th
                  scope="col"
                  data-tablesaw-sortable-col
                  data-tablesaw-priority="3"
                  className="border"
                >
                  {ar.title}
                </th>
                <th
                  scope="col"
                  data-tablesaw-sortable-col
                  data-tablesaw-priority="2"
                  className="border"
                >
                  {ar.votes}
                </th>
                <th scope="col" className="border">
                  {ar.delete}
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.polls.map((poll, index) => this.renderPolls(poll))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
